/*
 * @Author: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @Date: 2022-10-14 13:49:20
 * @LastEditors: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @LastEditTime: 2022-11-02 14:27:43
 * @FilePath: \shared-portal-web\packages\login\src\plugins\basic-components.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'

import {
  Row,
  Col,
  Card,
  Input,
  Button,
  Message,
  Loading,
  Form,
  FormItem,
  Dialog,
  Header,
  Container,
  Main,
  Footer,
  Menu,
  MenuItem,
  Submenu,
  Carousel,
  CarouselItem,
  Scrollbar,
  Backtop,
  Image,
  Cascader,
  Tabs,
  TabPane,
  Pagination
} from '@geip/basic-components'

const components = [
  // Alert,
  Row,
  Col,
  Card,
  Input,
  Button,
  Form,
  FormItem,
  Dialog,
  Header,
  Container,
  Main,
  Footer,
  Menu,
  MenuItem,
  Submenu,
  Carousel,
  CarouselItem,
  Scrollbar,
  Backtop,
  Image,
  Cascader,
  Tabs,
  TabPane,
  Pagination
]

components.forEach(item => {
  Vue.use(item)
})
Vue.use(Loading.directive)

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.prototype.$message = Message
